import type { PackageNotificationLogDTO } from "../../domain/contracts/queue";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@devhop/ui";
import { maskPhoneNumber } from "./WorkerStatusBanner";
import { NotificationDetailTextCell } from "./NotificationDetailTextCell";
import {
  formatNotificationDateTime,
  LogStatusBadge,
  PackageTypeBadge,
  TriggerBadge,
} from "./notification-table-badges";

export function NotificationLogsTable({
  items,
  hasActiveFilter,
}: {
  items: PackageNotificationLogDTO[];
  hasActiveFilter?: boolean;
}) {
  return (
    <div className="overflow-x-auto rounded-lg border">
      <Table className="min-w-[1040px]">
        <TableHeader>
          <TableRow className="bg-muted/40 hover:bg-muted/40">
            <TableHead className="w-[7.5rem]">ເວລາ</TableHead>
            <TableHead className="min-w-[9rem]">ນັກຮຽນ</TableHead>
            <TableHead>ແພັກ</TableHead>
            <TableHead>Trigger</TableHead>
            <TableHead>ສະຖານະ</TableHead>
            <TableHead>ເບີ</TableHead>
            <TableHead className="min-w-[10rem]">ເຫດຜົນ</TableHead>
            <TableHead className="min-w-[12rem]">ຂໍ້ຄວາມ</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.length === 0 ? (
            <TableRow>
              <TableCell colSpan={8} className="py-12 text-center">
                <p className="font-medium text-muted-foreground">
                  ຍັງບໍ່ມີປະຫວັດ
                </p>
                {hasActiveFilter ? (
                  <p className="mt-1 text-muted-foreground text-sm">
                    ລອງປັບກັ່ນຕົວສະຖານະ
                  </p>
                ) : null}
              </TableCell>
            </TableRow>
          ) : (
            items.map((log) => (
              <TableRow key={log.id} className="hover:bg-muted/20">
                <TableCell className="whitespace-nowrap tabular-nums text-sm">
                  {formatNotificationDateTime(log.sentAt ?? log.createdAt)}
                </TableCell>
                <TableCell>
                  <div className="font-medium">
                    {log.studentName ?? log.studentId}
                  </div>
                </TableCell>
                <TableCell>
                  <PackageTypeBadge packageType={log.packageType} />
                </TableCell>
                <TableCell>
                  <TriggerBadge triggerType={log.triggerType} />
                </TableCell>
                <TableCell>
                  <LogStatusBadge status={log.status} />
                </TableCell>
                <TableCell className="font-mono text-sm">
                  {maskPhoneNumber(log.phoneNumber)}
                </TableCell>
                <TableCell className="align-top">
                  <NotificationDetailTextCell
                    text={log.skipReason}
                    dialogTitle="ເຫດຜົນ / ຂໍ້ຜິດພາດ"
                    variant="error"
                  />
                </TableCell>
                <TableCell className="align-top">
                  <NotificationDetailTextCell
                    text={log.messageBody}
                    dialogTitle="ຂໍ້ຄວາມທີ່ສົ່ງ"
                  />
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
